import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './app-main.component.html',
  styleUrls: ['./app-main.component.scss']
})
export class AppMainComponent implements OnInit {
  activeInlineProfile: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
